import { render, staticRenderFns } from "./TeacherItem.vue?vue&type=template&id=33f0326e&scoped=true&"
import script from "./TeacherItem.vue?vue&type=script&lang=js&"
export * from "./TeacherItem.vue?vue&type=script&lang=js&"
import style0 from "./TeacherItem.vue?vue&type=style&index=0&id=33f0326e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f0326e",
  null
  
)

export default component.exports